<template>
  <div>
    
    <p class="f-msg" v-if="footerType === '02' && footerMsgShow === true">
      <span style="color: #1a61af;"
        ><b style="font-weight: bold;">상담원 연결</b>을 원하실 경우
        <b style="font-weight: bold;"
          >상단의 아이콘(
          <img src="@/assets/icon_fmsg.png" />
          )</b
        >을 선택해주세요.</span
      >
      <br />
      3G, LTE, 5G 환경에서 데이터 요금이 발생합니다.
    </p>
    
    <p
      class="f-msg"
      :class="footerClass"
      v-if="footerType !== '02' && footerMsgShow === true"
    >
      3G, LTE, 5G 환경에서 데이터 요금이 발생합니다.
    </p>
    
    <ul class="call-ui call-type-C" v-if="footerType === '01'">
      <li class="call-ui-done">
        <button type="" class="btn" @click="clickBtnDIS">
          <div class="icon icons-end"></div>
          <div class="text">통화종료</div>
        </button>
      </li>
    </ul>
    <ul class="call-ui call-type-C" v-if="footerType === '03'">
      <li class="call-ui-done">
        <button
          type=""
          class="btn"
          @click="clickBtnOK"
          :disabled="footerBtnEnable == false"
        >
          <div class="text">{{ footerBtnName }}</div>
        </button>
      </li>
    </ul>
    <ul class="call-ui call-type-C" v-if="footerType === '04'">
      <li class="call-ui-done">
        <button type="" class="btn" @click="clickBtnSurvey">
          <div class="text">참여 완료</div>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("manageUI", {
      footerType: state => state.footerType,
      footerMsgShow: state => state.isFooterMsgShow,
      footerClass: state => state.footerClass,
      footerBtnName: state => state.footerBtnName,
      footerBtnEnable: state => state.footerBtnEnable
    })
  },
  methods: {
    clickBtnDIS() {
      this.reqIVR("DIS", null, () => {
        this.closeService(true);
      });
    },
    clickBtnOK() {
      if (this.footerBtnEnable == true) {
        this.$store.dispatch(
          "manageUI/setFooterBtnClicked",
          this.$CONST.BTN_KND_OK
        );
      }
    }
  }
};
</script>
